(() => {
  const root = document.querySelector('#clubhaus-reviews .ch-reviews-feed');
  if (!root) return;
  const build = () => {
    if (root.classList.contains('ch-reviews-enhanced')) return;
    const source = root.querySelector('.jdgm-testimonials-carousel');
    if (!source) return;
    const seen = new Set();
    const selected = Array.from(source.querySelectorAll('.jdgm-card')).filter(card => {
      const text = card.querySelector('.jdgm-text')?.textContent.trim();
      const stars = card.querySelectorAll('.jdgm-rating-section .jdgm-star.jdgm--on').length;
      if (!text || text.length < 60 || text.length > 500 || stars !== 5 || seen.has(text)) return false;
      seen.add(text);
      return true;
    }).slice(0, 3);
    if (selected.length < 3) return;
    const display = document.createElement('div');
    display.className = 'ch-real-reviews';
    const summary = source.querySelector('.jdgm-header-info');
    if (summary) {
      const copy = summary.cloneNode(true);
      copy.classList.add('ch-review-summary');
      display.append(copy);
    }
    selected.forEach(card => {
      const item = document.createElement('figure');
      item.className = 'ch-real-review';
      item.dataset.reviewId = card.dataset.reviewId;
      const rating = document.createElement('span');
      rating.className = 'ch-review-stars';
      rating.setAttribute('aria-label', '5 out of 5 stars');
      rating.textContent = '★★★★★';
      const quote = document.createElement('blockquote');
      quote.textContent = card.querySelector('.jdgm-text').textContent.trim();
      const caption = document.createElement('figcaption');
      const name = document.createElement('strong');
      name.textContent = card.querySelector('.jdgm-reviewer-name')?.textContent.trim() || '';
      caption.append(name);
      if (card.querySelector('.jdgm-reviewer-verified-icon')) {
        const verified = document.createElement('span');
        verified.className = 'ch-review-verified';
        verified.textContent = 'Verified reviewer';
        caption.append(verified);
      }
      const link = card.querySelector('.jdgm-product-name a');
      if (link) {
        const product = document.createElement('a');
        product.href = link.href;
        product.textContent = link.textContent.trim();
        caption.append(product);
      }
      item.append(rating, quote, caption);
      display.append(item);
    });
    root.append(display);
    root.classList.add('ch-reviews-enhanced');
    observer.disconnect();
  };
  const observer = new MutationObserver(build);
  observer.observe(root, {childList:true, subtree:true});
  build();
})();
